// @ts-ignore
import arrow from '@assets/img/vector/other/arrow.svg';
import React from 'react';
export var ArrowRight = function (_a) {
    var onClick = _a.onClick;
    return (React.createElement("div", { onClick: onClick, className: "carousel__arrow carousel__arrow--right" },
        React.createElement("span", { dangerouslySetInnerHTML: { __html: arrow } })));
};
